"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Rectangle_1 = __importDefault(require("../../../loaders/Rectangle/Rectangle"));
require("./campaignMediaActionRowLoader.scss");
function CampaignMediaActionRowLoader(props) {
    return props.isMobile ? (react_1.default.createElement("div", { id: "media-action-row-loader-mobile" },
        react_1.default.createElement("div", { className: "media-cont" },
            react_1.default.createElement(Rectangle_1.default, { width: 100, radius: 0, height: 750 })))) : (react_1.default.createElement("div", { id: "media-action-row-loader-web" },
        react_1.default.createElement("div", { className: "media-cont" },
            react_1.default.createElement(Rectangle_1.default, { width: 100, radius: 0, height: 600 }))));
}
exports.default = CampaignMediaActionRowLoader;
